export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const FORM_NAME = 'driver-change-modal-name';

export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm:ss';

export const REQUIRED_FIELDS = ['driver_id'];
